import {Component, Inject, OnInit} from '@angular/core';
import {DIALOG_DATA, DialogRef} from '@angular/cdk/dialog';
import {STREAM_TYPES} from '../player.component';
import {FormatTrackLanguagePipe} from '../format-track-language.pipe';
import {FormsModule} from '@angular/forms';


@Component({
  selector: 'app-player-select-text',
  templateUrl: './player-select-text.component.html',
  styleUrls: ['./player-select-text.component.scss'],
  imports: [
    FormsModule,
    FormatTrackLanguagePipe,
]
})
export class PlayerSelectTextComponent implements OnInit {
  currentlySelectedRendition: Number;
  renditions: any;
  activeRenditionId: Number;
  streamTypeHLS: boolean;
  streamTypeDASH: boolean;

  constructor(protected dialogRef: DialogRef<Number>,
              @Inject(DIALOG_DATA) data: {
                renditions: any[],
                activeRenditionId: Number,
                streamTypeHLS: boolean,
                streamTypeDASH: boolean
              }) {
    this.renditions = data.renditions;
    this.activeRenditionId = data.activeRenditionId;
    this.currentlySelectedRendition = data.activeRenditionId
    this.streamTypeHLS = data.streamTypeHLS
    this.streamTypeDASH = data.streamTypeDASH
  }

  ngOnInit(): void {
  }

  protected readonly STREAM_TYPES = STREAM_TYPES;
}
